import React from 'react'

interface IProps {
  value: boolean
}

const MandatoryCourse = ({ value }: IProps) => {
  return <div>{value ? 'Requerido' : 'Opcional'}</div>
}

export default MandatoryCourse
